import type { Database } from '@/shared/types/supabase'

export type ExternalContact = Database['public']['Tables']['external_contacts']['Row']
export type ExternalContactInsert = Database['public']['Tables']['external_contacts']['Insert']
export type ExternalContactUpdate = Database['public']['Tables']['external_contacts']['Update']

export type ContactType = Database['public']['Enums']['contact_type']
export type NotificationPreference = Database['public']['Enums']['notification_preference']

export const CONTACT_TYPE_LABELS: Record<ContactType, string> = {
  mandataire: 'Mandataire',
  representant_legal: 'Représentant légal',
  notaire: 'Notaire',
  administrateur_judiciaire: 'Administrateur judiciaire',
  autre: 'Autre',
}

export const CONTACT_TYPE_OPTIONS = Object.entries(CONTACT_TYPE_LABELS).map(([value, label]) => ({
  value: value as ContactType,
  label,
}))

export const NOTIFICATION_PREFERENCE_LABELS: Record<NotificationPreference, string> = {
  ELECTRONIC: 'Email (LRE)',
  PAPER: 'Courrier postal (LRAR)',
}

export const NOTIFICATION_PREFERENCE_OPTIONS = Object.entries(NOTIFICATION_PREFERENCE_LABELS).map(([value, label]) => ({
  value: value as NotificationPreference,
  label,
}))
